<script>

export default {
  name: "PackageIcon",
  props: {
    color: {
      type: String,
      default: "currentColor",
    },
  }
};

</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none" role="img" aria-label="Ícone de pacote">
    <title>Ícone de pacote</title>
    <path
      d="M7.34998 15.5986V8.09856M7.34998 8.09856L0.817505 4.34856M7.34998 8.09856L13.8825 4.34856M3.97498 2.30106L10.725 6.16356M6.59998 15.3961C6.828 15.5277 7.08667 15.597 7.34998 15.597C7.61328 15.597 7.87195 15.5277 8.09998 15.3961L13.35 12.3961C13.5778 12.2645 13.767 12.0754 13.8986 11.8477C14.0303 11.62 14.0997 11.3616 14.1 11.0986V5.09856C14.0997 4.83552 14.0303 4.57717 13.8986 4.34943C13.767 4.1217 13.5778 3.93258 13.35 3.80106L8.09998 0.801059C7.87195 0.669407 7.61328 0.600098 7.34998 0.600098C7.08667 0.600098 6.828 0.669407 6.59998 0.801059L1.34998 3.80106C1.12217 3.93258 0.932961 4.1217 0.801322 4.34943C0.669683 4.57717 0.600245 4.83552 0.599976 5.09856V11.0986C0.600245 11.3616 0.669683 11.62 0.801322 11.8477C0.932961 12.0754 1.12217 12.2645 1.34998 12.3961L6.59998 15.3961Z"
      :stroke="color" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>